/**
 * Copies a step and increments a trailing number in it's label,
 * or adds said trailing number
 *
 * @param step step to clone
 * @param labelSet set containing all labels. Will me mutated to include new label
 * @returns cloned step
 */
export function cloneStepWithUniqueLabel(step, labelSet) {
    var _a, _b;
    const newStep = structuredClone(step);
    if (newStep.label) {
        while (labelSet.has(newStep.label)) {
            const number = (_a = newStep.label.match(/[0-9]+$/)) === null || _a === void 0 ? void 0 : _a[0];
            if (number) {
                const count = parseInt(number);
                newStep.label = (_b = newStep.label) === null || _b === void 0 ? void 0 : _b.replace(/[0-9]+$/, `${count + 1}`);
            }
            else {
                newStep.label += " 2";
            }
        }
        labelSet.add(newStep.label);
    }
    return newStep;
}
export function getLabelSet(store) {
    const steps = Object.values(store.steps);
    const labels = steps.flatMap((step) => (step.label ? [step.label] : []));
    return new Set(labels);
}
